
import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { Observable } from 'rxjs';
import { OptimizePlanRequest } from "../../domain";
import { PlansRepository } from "../../repositories";

@Injectable({ providedIn: 'root' })
export class RemovePlanSchedulerUsecase implements UseCase<string, boolean> {

  constructor(private readonly planRepository: PlansRepository) {
  }

  execute(params: string): Observable<boolean> {
    return this.planRepository.removePlanScheduler(params);
  }

}
